/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute, FormState, FormStateBuilder } from '@gh/common-shared';
import { DialogInput, FormMode } from '@gh/core-ui';
import { DetailItem } from '../../../../resources/quote-structure.model';

export interface QuoteStructureDetailsDialogConfig {
  detail: DetailItem;
  hide: boolean;
}

@Component({
  selector: 'gh-quote-structure-details-description-dialog',
  template: require('./quote-structure-details-dialog.component.html'),
  styles: [require('./quote-structure-details-dialog.component.scss')],
})
export class QuoteStructureDetailsDialogComponent implements OnInit,
                                                             DialogInput<QuoteStructureDetailsDialogConfig> {
  input: QuoteStructureDetailsDialogConfig;
  form: FormState<DetailItem>;

  constructor(private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder) {

  }

  ngOnInit(): void {
    const detail = this.input.detail;

    this.form = this.formStateBuilder.buildPlain({
      value: detail,
      mode: FormMode.EditMode,
      enabled: true,
      children: {
        description: { required: true },
        hide: void 0,
      },
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    if (this.form.group.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.value);
  }
}

export const quoteStructureDetailsDialogRoute = createDialogRoute({
  component: QuoteStructureDetailsDialogComponent,
});
